export const basePath = '/corporate/enterprise';
